<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    aria-labelledby="guided-recording-dialog-title"
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 800 : 'auto'"
  >
    <v-card data-cy="guidedRecording-dialog">
      <v-card-title class="d-flex align-center justify-space-between ga-3">
        <span id="guided-recording-dialog-title">{{ $t('routes.guidedRecording.pageTitle') }}</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          :aria-label="$t('common.close')"
          @click="dialog = false"
        />
      </v-card-title>

      <v-card-text>
        <GuidedRecordingOrganizer
          v-if="dialog"
          :project-node-id="projectNodeId"
          :selected-invitation="selectedInvitation"
          embedded
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';
import GuidedRecordingOrganizer from '@/routes/guided-recording/GuidedRecordingOrganizer.vue';

export default {
  name: 'GuidedRecordingDialog',
  components: { GuidedRecordingOrganizer },
  mixins: [DialogActionKeys, DialogModel],
  props: {
    node: { type: Object, required: true },
    selectedInvitation: { type: Object, default: null },
  },
  computed: {
    projectNodeId() {
      return this.selectedInvitation?.projectnode?.id || this.node.id;
    },
  },
};
</script>

<style lang="scss" scoped>
@layer app {
  :deep(.guided-recording-organizer) {
    max-width: none;
    padding: 0;
  }
}
</style>
